import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {Material} from '../types'

import {materialsQueryOptions, MaterialsQueryKey} from './materialsQueryOptions'

export {MaterialsQueryKey}

type Params<TReturn = Material[]> = {
  plantCode: string
  options?: Omit<UseQueryOptions<Material[], AxiosError, TReturn>, 'queryKey' | 'queryFn'>
}

export const useMaterials = <TReturn = Material[]>({plantCode, options}: Params<TReturn>) =>
  useQuery<Material[], AxiosError, TReturn>({
    ...materialsQueryOptions(plantCode),
    ...options
  })
